(() => {
    const checkoutContainer = document.querySelector('.cart__checkout-container');

    const lockCheckout = () => {
        checkoutContainer.style.pointerEvents = 'none';
        checkoutContainer.style.filter = 'opacity(0.8)';
    }

    const unlockCheckout = () => {
        checkoutContainer.style.pointerEvents = 'auto';
        checkoutContainer.style.removeProperty('filter');
    }
    const addLaserCutting = () => {
        if (localStorage.getItem('addLaserCuttingProduct') === 'true') {
            lockCheckout();
            let formData = {
                items: [
                    {
                        id: 39496284831847,
                        quantity: 1
                    }
                ]
            };

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            })
                .then(response => {
                    return response.json();
                })
                .then(() => {
                    localStorage.setItem('addLaserCuttingProduct', 'false');
                    location.reload();
                })
                .catch(error => {
                    console.error('Error:', error);
                    unlockCheckout();
                });
        }
    };

    const updateLaserCutting = () => {
        let neededLaserCuttingCounter = 0;
        const laserCuttingInput = document.querySelector('.cart__card[data-variant-id="39496284831847"] .quantity-input');

        fetch('/cart.js').then(response => response.json()).then(cart => {
            cart.items.forEach((cartItem) => {
                if (cartItem.properties.Beschriftung && cartItem.properties.Beschriftung != "") {
                    neededLaserCuttingCounter += cartItem.quantity;
                }
            });

            if (laserCuttingInput != undefined && laserCuttingInput.value != neededLaserCuttingCounter) {
                lockCheckout();
                let formData = {
                    id: '39496284831847',
                    quantity: neededLaserCuttingCounter,
                };

                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                })
                    .then((cart) => {
                        console.log("UPDATE LASERCUTTING")
                        location.reload();
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        unlockCheckout();
                    });
            }
        });
    }

    // --- Custom Staffelrabatt progress bar auto-refresh ---
    // Recalculates the bar on every cart change (its own inline script binds on
    // DOMContentLoaded, which has already fired by the time it runs, so it never updates).
    // 'Individuelle Gravur' (variant 39496284831847) is a hidden add-on, not counted.
    const LASER_CUTTING_VARIANT = 39496284831847;
    const formatEuro = (cents) => (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    const updateCartProgressBar = () => {
        const barFill = document.querySelector('.progress-bar-fill');
        if (!barFill) return;

        fetch('/cart.js', { cache: 'no-store' }).then(response => response.json()).then(cart => {
            let promoCount = 0;
            cart.items.forEach(item => {
                if (item.variant_id !== LASER_CUTTING_VARIANT) {
                    promoCount += item.quantity;
                }
            });

            let percentage = promoCount * 25;
            if (percentage > 100) percentage = 100;
            barFill.style.width = percentage + '%';

            const msgDiv = document.querySelector('.promo-message');
            if (msgDiv) {
                if (promoCount === 0) {
                    msgDiv.innerHTML = 'Bestelle zwei Questlogs,<br class="mobile-break"> um <strong>10€ Rabatt</strong> zu erhalten.';
                } else if (promoCount === 1) {
                    msgDiv.innerHTML = 'Noch <strong>ein zweites Questlog</strong><br class="mobile-break"> für 10€ Rabatt!';
                } else if (promoCount === 2) {
                    msgDiv.innerHTML = 'Du hast <strong>10€ Rabatt</strong> gesichert!<br class="mobile-break"> Hol dir noch eins für <strong>20€ Rabatt!</strong>';
                } else if (promoCount === 3) {
                    msgDiv.innerHTML = '<strong>20€ Rabatt</strong> gesichert!<br class="mobile-break"> Das vierte bringt dir <strong>30€ Rabatt!</strong>';
                } else {
                    msgDiv.innerHTML = '🎉 Glückwunsch!<br class="mobile-break"> Du hast dir <strong>30€ Rabatt</strong> gesichert!';
                }
            }

            [['milestone-2', 2], ['milestone-3', 3], ['milestone-4', 4]].forEach(([cls, threshold]) => {
                const el = document.querySelector('.' + cls);
                if (el) el.classList.toggle('achieved', promoCount >= threshold);
            });

            cart.items.forEach((item, index) => {
                const itemRow = document.querySelector('.cart__card[data-cart-item="' + item.key + '"]') ||
                                document.querySelector('.cart__card[data-line-item="' + (index + 1) + '"]');
                if (itemRow) {
                    const lineTotalElement = itemRow.querySelector('.cart__total .money');
                    if (lineTotalElement) lineTotalElement.innerHTML = formatEuro(item.original_line_price);
                }
            });

            let customDiscountCents = 0;
            if (promoCount >= 4) customDiscountCents = 3000;
            else if (promoCount >= 3) customDiscountCents = 2000;
            else if (promoCount >= 2) customDiscountCents = 1000;

            const customDiscountRow = document.querySelector('.cart__custom-discount');
            if (customDiscountRow) {
                if (customDiscountCents > 0) {
                    customDiscountRow.style.display = 'flex';
                    const discountMoneyElement = customDiscountRow.querySelector('.money');
                    if (discountMoneyElement) discountMoneyElement.innerHTML = '-' + formatEuro(customDiscountCents);
                } else {
                    customDiscountRow.style.display = 'none';
                }
            }

            const unreducedElement = document.querySelector('.cart__unreduced-total .money');
            if (unreducedElement) unreducedElement.innerHTML = formatEuro(cart.total_price + customDiscountCents);

            const subtotalElement = document.querySelector('.cart__subtotal .money');
            if (subtotalElement) subtotalElement.innerHTML = formatEuro(cart.total_price);

            const freeShippingThresholdCents = 5000;
            const hasFreeShipping = cart.total_price >= freeShippingThresholdCents;
            const shippingNotFreeEl = document.querySelector('[data-shipping-not-free]');
            const shippingFreeEl = document.querySelector('[data-shipping-free]');
            if (shippingNotFreeEl) shippingNotFreeEl.style.display = hasFreeShipping ? 'none' : '';
            if (shippingFreeEl) shippingFreeEl.style.display = hasFreeShipping ? '' : 'none';
        }).catch(error => console.error('Progress bar update failed:', error));
    };

    if (localStorage.getItem('addLaserCuttingProduct') === 'true') {
        addLaserCutting();
    }

    document.addEventListener('rerenderCart', () => {
        updateLaserCutting();
        setTimeout(updateCartProgressBar, 50);
    });

    updateLaserCutting();
    updateCartProgressBar();
})();
